// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__VO5qY","text":"hero_text__CnnHr","btns":"hero_btns__k-QvH"};